import React, { useState, useEffect, useRef } from 'react';
import { useRouter } from 'next/router';
import { getLang } from 'lowcomp/plugins/member/utils';
import { useEcoStore } from 'lowcode/utils/context/ecocredits';
import { injectNotes } from 'lowcomp/plugins/member/utils';
import { textLang } from 'lowcomp/plugins/member/common/textLang';
import RuleModal from 'lowcomp/plugins/member/common/RuleModal';
import NoAward from 'lowcomp/plugins/member/common/NoAward';
import CouponModal from 'lowcomp/plugins/member/common/CouponModal';
import EditorLink from 'lowcode/components/EditorLink';
import isEmpty from 'lodash/isEmpty';
import { useMemberTimeStore } from 'lowcode/utils/context/memberTimeZone';
import { useLuckyStore, useLuckyDispatch } from './LuckyProvider';
import LuckyWheel from './NineGrid';
import styled from './index.module.scss';
import EFArrowRight from '@/components/UI/svg/Icons/EFArrowRight';
import { useGlobal } from '@/utils/useGlobal';
import getLocal from '@/app/utils/getLocal';
import { signupCookie } from '@/utils/cookies/signupCookie';
import { createPortal } from 'react-dom';
import LoginFormModal from '@/components/LoginFormModal';

interface LuckyTurntableProps {
    id: string;
    isEditStatus: boolean;
    isLogin: boolean;
    showListBtn: string;
    showRewardsBtn: string;
    bgImage: string;
    btnImage: string;
    btnDisabledImage: string;
    setShowPage: (page: string) => void;
    refershData?: () => void;
    loginType: 'page' | 'modal';
}

const LuckyTurntable: React.FC<LuckyTurntableProps> = ({
    id,
    isEditStatus,
    isLogin,
    showListBtn,
    showRewardsBtn,
    bgImage,
    btnImage,
    btnDisabledImage,
    setShowPage,
    refershData,
    loginType = 'page',
}) => {
    const { isMobile } = useGlobal();
    const dispatch = useLuckyDispatch();
    const { LUCKY_ACTIVE: luckyActivety } = useLuckyStore();
    const { inBlackList } = useEcoStore();
    const router = useRouter();
    const { locale } = getLocal();
    const t = getLang(textLang, locale);
    const [currNotes, setCurrNotes] = useState<any>();
    const [winnerPrize, setWinnerPrize] = useState<any>();
    const [showLoginModal, setShowLoginModal] = useState(false);
    const [isClient, setIsClient] = useState(false);
    const [activeIndex, setActiveIndex] = useState<number | null>(null);
    // {
    //     awardsId: '1848303787229442049',
    //     drawId: '1844641002630934530',
    //     points: 1,
    //     prizeId: '1847457135651401729',
    //     prizeName: '积分',
    //     prizeType: 'INTEGRAL',
    // }
    // {
    //     drawId: '1844641002630934530',
    //     awardsId: '1852617586973720578',
    //     prizeId: '1852617520376619009',
    //     prizeType: 'COUPONS',
    //     prizeName: '优惠券2',
    //     discountId: '1820787499396276226',
    //     discountName: 'US-等级2优惠券-300$',
    //     rewardRedeemRespVo: {
    //         id: '1852617680276013057',
    //         website: 'USA',
    //         site: 'US',
    //         appid: 1,
    //         ruleId: '1820787499396276226',
    //         ruleType: 'COUPONS',
    //         source: 'COUPONS_ORDERS',
    //         discountType: 'fixed_amount',
    //         currency: 'USD',
    //         currencySymbol: '$',
    //         amount: 300.0,
    //         points: '1',
    //         coupon: 'CA2DERUAHBYJWKAOZDJH',
    //         useStatus: 'UNUSED',
    //         startTime: '1730533448000',
    //         endTime: '1733125448000',
    //         jumpUrl: '',
    //         prerequisite: 'PRICES',
    //         prerequisiteRange: '2000',
    //         rulePic: '',
    //     },
    // }
    const [isValidTime, setIsValidTime] = useState(true);
    const timer = useRef<number>();
    const pathUrl = `/${locale}/ecocredits`;
    const { timezoneList } = useMemberTimeStore();

    // debug 类型3
    // if (luckyActivety) luckyActivety.playWays = 3;

    const getRemainingTimesText = () => {
        const { limitCount, limitDay, playWays } = luckyActivety || {};

        // 活动期间
        if (limitDay === -1) {
            return t.rich('limit_times_in_active', { count: () => <i className="remaining-times-count">{limitCount || 0}</i> });
        }

        // 不限时间参与
        if (limitDay === 1000000000) {
            return t.rich('without_limit_times', { count: () => <i className="remaining-times-count">{limitCount || 0}</i> });
        }

        const day = Math.round(limitDay / 60 / 24);
        // 韩法单天文案调整
        if (locale === 'kr' && day <= 1) {
            return t.rich('limit_times_in_day_one', {
                count: () => <i className="remaining-times-count">{limitCount || 0}</i>,
            });
        }
        if (locale === 'fr' && day <= 1) {
            return t.rich('limit_times_in_day_one', {
                count: () => <i className="remaining-times-count">{limitCount || 0}</i>,
                day: () => <i className="remaining-times-count">{day}</i>,
            });
        }
        return t.rich('limit_times_in_day', {
            count: () => <i className="remaining-times-count">{limitCount || 0}</i>,
            day: () => <i className="remaining-times-count">{day}</i>,
        });
    };

    const openRuleModal = () => {
        const ruleList = luckyActivety?.description?.split('\n')?.filter((str: string) => !!str);
        setCurrNotes(ruleList || []);
    };

    const getIsValidTime = () => {
        if (!luckyActivety) return;
        const { startTime, endTime } = luckyActivety;
        const startTimestamp = Number(startTime);
        const endTimestamp = Number(endTime);

        // 不能转换成时间戳，不做处理
        if (Number.isNaN(startTimestamp) || Number.isNaN(endTimestamp)) {
            return;
        }

        const now = new Date().valueOf();
        const newIsValidTime = startTimestamp < now && endTimestamp > now;
        if (isValidTime !== newIsValidTime) {
            setIsValidTime(newIsValidTime);
        }
    };

    const handleAddNotes = (coupon: any) => {
        if (!coupon) return;
        if (coupon.ruleType === 'COUPONS') {
            return injectNotes([coupon], t, locale, timezoneList)[0];
        }

        if (coupon?.ruleDescription) {
            const noteList = coupon?.ruleDescription?.split('\n')?.filter((str: string) => !!str);
            return {
                ...coupon,
                noteList,
            };
        }
    };

    useEffect(() => {
        timer.current = window.setInterval(getIsValidTime, 500);
        return () => {
            timer.current && window.clearInterval(timer.current);
        };
    }, [luckyActivety, isValidTime]);

    useEffect(() => {
        if (id) {
            dispatch({
                type: 'getActives',
                payload: { isEditStatus, locale, id },
            });
        }
        if (!id && isEditStatus) {
            dispatch({
                type: 'GET_ACTIVE_LIST_TYPES',
                payload: {
                    title: '模块主标题',
                    subTitle: '模块副标题',
                },
            });
        }
    }, [id]);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);

    const btnTools = (className: string) => {
        if (!['us', 'ca'].includes(locale)) return <></>;
        return (
            <div className={`nineGrid-left-tools ${className}`}>
                {showListBtn === 'Y' && (
                    <EditorLink
                        className="rewards_list"
                        onClick={() => {
                            if (!isLogin) {
                                signupCookie?.({
                                    sector_name: luckyActivety?.title,
                                    entry_position: 0,
                                });
                                if (loginType === 'modal') {
                                    setShowLoginModal(true);
                                    return;
                                }
                                router.push(`/${locale}/login?redirect=${window.location.href}`);
                                return;
                            }
                            setShowPage('lucky_history');
                            refershData && refershData();
                        }}
                        dataLayer={{
                            event: 'uaEvent',
                            event_name: 'activity_join_login',
                            button_name: t('lucky_rewards_list'),
                        }}
                    >
                        {t('lucky_rewards_list')}
                    </EditorLink>
                )}
                {showRewardsBtn === 'Y' && (
                    <EditorLink
                        className="my_rewards"
                        onClick={() => {
                            if (!isLogin) {
                                signupCookie?.({
                                    sector_name: luckyActivety?.title,
                                    entry_position: 0,
                                });
                                if (loginType === 'modal') {
                                    setShowLoginModal(true);
                                    return;
                                }
                                router.push(`/${locale}/login?redirect=${window.location.href}`);
                                return;
                            }
                            setShowPage('coupon_modal');
                            refershData && refershData();
                        }}
                        dataLayer={{
                            event: 'uaEvent',
                            event_name: 'activity_join_login',
                            button_name: t('rewards_redeemed'),
                        }}
                    >
                        {t('rewards_redeemed')}
                    </EditorLink>
                )}
            </div>
        );
    };


    if (!isEditStatus && isEmpty(luckyActivety)) return <></>;

    return (
        <>
            <div id="LUCKY_TURNTABLE" className={styled.nineGrid}>
                <div className="nineGrid-content">
                    <div className="nineGrid-left">
                        <div className="nineGrid-left-text-content">
                            <h5 className="nineGrid-title">{luckyActivety?.title}</h5>

                            <p className="nineGrid-desc">{luckyActivety?.subTitle}</p>

                            {!!luckyActivety?.limitFlag && <p className="nineGrid-limit-rule">{getRemainingTimesText()}</p>}

                            {luckyActivety?.type === 2 && (
                                <p className="nineGrid-desc2">{t('join_lucky_with_points2', { points: luckyActivety?.usePoints || 0 })}</p>
                            )}
                            {!!luckyActivety?.description && (
                                <div onClick={openRuleModal} className="nineGrid-rule-more">
                                    {t('learn_lucky_rule')}
                                    <EFArrowRight />
                                </div>
                            )}
                            {/* 移动端剩余次数 */}
                            {/* {!!luckyActivety?.limitFlag && (
                                <p className="remaining-times-text mobile">
                                    {t.rich('remaining_number', {
                                        code: () => <i className="remaining-times-count">{luckyActivety?.available || 0}</i>,
                                    })}
                                </p>
                            )} */}
                            {btnTools('pc')}
                        </div>
                    </div>

                    <div className="nineGrid-right">
                        <div className="nineGrid-panel-content">
                            <LuckyWheel
                                bgImage={bgImage}
                                btnImage={btnImage}
                                btnDisabledImage={btnDisabledImage}
                                disabled={inBlackList || !isValidTime || (luckyActivety?.limitFlag && !luckyActivety?.available)}
                                isLogin={isLogin}
                                loginType={loginType}
                                prizes={luckyActivety?.drawAwards || []}
                                drawInfo={luckyActivety}
                                available={luckyActivety?.available || 0}
                                onEndRotating={(winnerPrize) => {
                                    if (winnerPrize) {
                                        setWinnerPrize(winnerPrize);
                                    }

                                    dispatch({
                                        type: 'getActives',
                                        payload: { isEditStatus, locale, id },
                                    });
                                    refershData?.();
                                }}
                                onCheckError={() => {
                                    dispatch({
                                        type: 'getActives',
                                        payload: { isEditStatus, locale, id },
                                    });
                                    refershData?.();
                                }}
                                pathUrl={pathUrl}
                                limitFlag={!!luckyActivety?.limitFlag}
                                activeIndex={activeIndex}
                                setActiveIndex={setActiveIndex}
                            />
                        </div>

                        {/* pc: 剩余抽奖次数 */}
                        {!!luckyActivety?.limitFlag && (
                            <p className="remaining-times-text">
                                {t.rich('remaining_number', {
                                    code: () => <i className="remaining-times-count">{luckyActivety?.available || 0}</i>,
                                })}
                            </p>
                        )}
                        {btnTools('mobile')}
                    </div>
                </div>
            </div>
            {/* 活动规则弹框 */}
            <RuleModal currNotes={currNotes} setCurrNotes={setCurrNotes} />
            {/* 未中奖弹框 */}
            <NoAward
                desc={winnerPrize?.tips}
                open={(winnerPrize?.prizeType === 'NOTHING' || winnerPrize?.type === 'NOTHING') && luckyActivety?.playWays === 4}
                onCancel={() => {
                    setWinnerPrize(undefined);
                    setActiveIndex(null);
                }}
            />
            {/* 优惠券弹框 */}
            {['THIRD_COUPONS', 'COUPONS', 'INTEGRAL'].includes(winnerPrize?.prizeType||winnerPrize?.type) && (
                <CouponModal
                    open={['THIRD_COUPONS', 'COUPONS', 'INTEGRAL'].includes(winnerPrize?.prizeType||winnerPrize?.type)}
                    prize={luckyActivety?.drawAwards || []}
                    winnerPrize={winnerPrize}
                    coupon={handleAddNotes(winnerPrize?.rewardRedeemRespVo)}
                    setShowPage={setShowPage}
                    onCancel={() => {
                        setWinnerPrize(undefined);
                        setActiveIndex(null);
                    }}
                />
            )}

            {isClient &&
                showLoginModal &&
                createPortal(
                    <LoginFormModal
                        visible={showLoginModal}
                        onCancel={() => {
                            setShowLoginModal(false);
                        }}
                        type="passwordless"
                    />,
                    document.body,
                )}
        </>
    );
};

export default LuckyTurntable;
